import Action, { ActionServiceInfo , ActionServiceInfoFetchError,ActionAddOrderError, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import ServiceInfoState from '../State/ServiceInfoState'
import { enqueueSnackbar } from 'notistack'

const actionServiceInfoFetchError = (oldState: ServiceInfoState, action: Action): ServiceInfoState => {
    return { ...oldState, error: (action as ActionServiceInfoFetchError).message, loading: false }
}

const actionServiceeInfoFetchLoading = (oldState: ServiceInfoState, _action: Action): ServiceInfoState => {
    return { ...oldState, loading: true, error: undefined }
}

const actionServiceInfo = (oldState: ServiceInfoState, action: Action): ServiceInfoState => {
    return { ...oldState, loading: false, error: undefined, data: (action as ActionServiceInfo).list }
}

const actionOrderLoading = (oldState: ServiceInfoState, action: Action): ServiceInfoState => {
    return { ...oldState, ordering : true }
}


const actionOrderError = (oldState: ServiceInfoState, action: Action): ServiceInfoState => {
    let error = (action as ActionAddOrderError).message
    if(error === 'low balance'){
        enqueueSnackbar('موجودی کیف پول کافی نیست', { autoHideDuration: 3000, variant: 'error', preventDuplicate: true, anchorOrigin: { vertical: 'top', horizontal: 'right' } })

    }else{
        enqueueSnackbar('عملیات انجام نشد | لطفا دقایقی دیگه تلاش کنید', { autoHideDuration: 3000, variant: 'error', preventDuplicate: true, anchorOrigin: { vertical: 'top', horizontal: 'right' } })

    }

    return { ...oldState, ordering : false }
}

const actionOrderDone = (oldState: ServiceInfoState, action: Action): ServiceInfoState => {
    enqueueSnackbar('سفارش با موفقیت ثبت شد', { autoHideDuration: 3000, variant: 'success', preventDuplicate: true, anchorOrigin: { vertical: 'top', horizontal: 'right' } })

    return { ...oldState, ordering : false }
}
type Process = (oldState: ServiceInfoState, action: Action) => ServiceInfoState

export const ServiceInfoReducer: Reducer<ServiceInfoState, Action> = (state: ServiceInfoState = {
    data: [], loading: false, error: undefined , ordering : false
}, action: Action): ServiceInfoState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.SERVICE_INFO_LOADING, actionServiceeInfoFetchLoading)
    actionMap.set(ActionType.SERVICE_INFO_DATA, actionServiceInfo)
    actionMap.set(ActionType.SERVICE_INFO_ERROR, actionServiceInfoFetchError)


    actionMap.set(ActionType.SERVICE_ADD_ORDER_LOADING, actionOrderLoading)
    actionMap.set(ActionType.SERVICE_ADD_ORDER_ERROR, actionOrderError)
    actionMap.set(ActionType.SERVICE_ADD_ORDER_DONE, actionOrderDone)

    

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}
